/**
 * Trechos prontos para colar em cada cliente MCP.
 * Sem token recém-gerado, usa um marcador que a pessoa troca.
 */

export const MARCADOR_DO_TOKEN = "SEU_TOKEN_AQUI";

export type ClienteMcp = "claude-code" | "claude-desktop" | "cursor" | "outros";

export type TrechoDeConfiguracao = {
  readonly cliente: ClienteMcp;
  readonly rotulo: string;
  readonly onde: string;
  readonly linguagem: "bash" | "json" | "texto";
  readonly codigo: string;
};

export function urlDoServidorMcp(origem: string): string {
  return `${origem.replace(/\/+$/, "")}/api/mcp`;
}

/** O que a pessoa cola no chat depois que o app já está ligado. Sem token. */
export function recadoDepoisDeConectar(): string {
  return [
    "Use o Creative OS, que já está ligado neste chat.",
    "",
    "Antes de qualquer coisa, pergunte qual projeto eu quero, por exemplo Renke Academy. A conta pode ter vários.",
    "Antes de gravar, mostre o que vai mudar e espere um sim.",
    "Se uma rede não estiver conectada, avise e não agende nela.",
  ].join("\n");
}

export function trechosDeConfiguracao(
  url: string,
  token: string | null,
): readonly TrechoDeConfiguracao[] {
  const t = token ?? MARCADOR_DO_TOKEN;
  return [
    {
      cliente: "claude-code",
      rotulo: "Claude Code",
      onde: "Rode no terminal, uma vez.",
      linguagem: "bash",
      codigo: `claude mcp add --transport http creative-os ${url} --header "Authorization: Bearer ${t}"`,
    },
    {
      cliente: "claude-desktop",
      rotulo: "Claude Desktop",
      onde:
        "Configurações → Desenvolvedor → Editar config (claude_desktop_config.json). Precisa de Node instalado. Reinicie o app depois.",
      linguagem: "json",
      codigo: JSON.stringify(
        {
          mcpServers: {
            "creative-os": {
              command: "npx",
              args: [
                "-y",
                "mcp-remote",
                url,
                "--header",
                "Authorization:${CREATIVE_OS_AUTH}",
              ],
              env: { CREATIVE_OS_AUTH: `Bearer ${t}` },
            },
          },
        },
        null,
        2,
      ),
    },
    {
      cliente: "cursor",
      rotulo: "Cursor",
      onde: "Arquivo ~/.cursor/mcp.json (ou .cursor/mcp.json no projeto).",
      linguagem: "json",
      codigo: JSON.stringify(
        {
          mcpServers: {
            "creative-os": {
              url,
              headers: { Authorization: `Bearer ${t}` },
            },
          },
        },
        null,
        2,
      ),
    },
    {
      cliente: "outros",
      rotulo: "Outros",
      onde: "Qualquer cliente MCP com transporte HTTP (Streamable HTTP).",
      linguagem: "texto",
      codigo: `URL: ${url}\nCabeçalho: Authorization: Bearer ${t}`,
    },
  ];
}
